<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import MonitoraTable from './monitora-table'
import appConfig from "@/app.config";
import Swal from "sweetalert2"
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/monitoramento_anim.json'

import {clientesChart1, clientesChart2 } from "../components/data-simulados";
import exportFromJSON from "export-from-json";
import moment from "moment/moment";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import { DxColumn, DxColumnChooser, DxColumnFixing, DxDataGrid, DxExport, DxFilterRow, DxGrouping, DxGroupPanel,
  DxPager, DxRemoteOperations, DxStateStoring } from "devextreme-vue/data-grid"; //DxSelection,
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import {saveAs} from "file-saver-es";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Monitoramento XML",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    DxColumnFixing, DxExport, DxDataGrid, DxColumn, DxColumnChooser, DxFilterRow, DxGroupPanel, DxPager, DxRemoteOperations,
    DxStateStoring, DxGrouping, DxButton, DxToolbar, DxItem, Layout, PageHeader, Loader, Vue3Lottie
  }, //MonitoraTable, DxSelection,

  data() {
    return {
      animationJson,
      title: 'Relatórios de Orçamentos',
      items: [
        {
          text: 'Orcamentos',
          href: '/',
        },
        {
          text: 'Relatórios',
          active: true,
        },
      ],
      loadingList: true,
      orcamentoList: null,
      monitorasList: null,
      updating: false,
      periodo: null,
      periodoPesq: false,
      cliChart1: clientesChart1,
      cliChart2: clientesChart2,
      pesqTextFilter: '',
      statusFilter: 'T',
      submittedPeriodo: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
    }
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance;
    },
  },

  mounted() {
    console.log('mounted monitora-list_0')
    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    // const mesAtu = ("0" + (dataAtu.getMonth() + 1)).slice(-2)
    const mesAtu = ("0" + (dataAtu.getMonth())).slice(-2)
    // console.log(dataAtu.getFullYear())
    // console.log(dataAtu.getMonth())
    // console.log(mesAtu)
    // console.log(anoAtu)
    this.periodo = anoAtu + '-' + mesAtu
    this.atualizaDataList()
  },

  methods: {

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      this.produtoList = null

      const filtros = JSON.parse(localStorage.getItem('filtros')) || {};

      filtros.movdi = moment(this.dtIniFiltro).format('YYYY-MM-DD');
      filtros.movdf = moment(this.dtFimFiltro).format('YYYY-MM-DD');

      localStorage.setItem('filtros', JSON.stringify(filtros));

      this.atualizaDataList()
    },

    atualizaDataList(){

      const filtros = JSON.parse(localStorage.getItem("filtros"))

      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
        this.periodoPesq = filtros['tipoFilter']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro) {
        console.log('sem filtro')
        let perIniPadrao = moment().add(-30, 'days').startOf('month').format('YYYY-MM-DD')
        // let perIniPadrao = moment().add(-1, 'days').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      this.loadingList = true
      api.get(`${getBaseUrl()}api/relatorcto`, {
        params: {
          'tp': this.periodoPesq,
          's': this.statusFilter,
          'di': this.dtIniFiltro,
          'df': this.dtFimFiltro,
          'fm': this.periodo,
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.title = `Relatórios de Orçamentos`
        this.loadingList = false

        this.orcamentoList = res.data

        /*const dtIniFormated = moment(this.dtIniFiltro)
            .format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro)
            .format('DD/MM/YYYY')

        this.title = `Relatórios de Orçamento: periodo(${dtIniFormated} - ${dtFimFormated})`*/

        // api.post(`${getBaseUrl()}api/postnfeconsch`,  {
        //   idData: 472
        // }).then((res) => {
        //   console.log('then axios')
        //   console.log(res)
        // })



      });
    },


    carregouGrid(e) {
      console.log("carregouGrid");
      console.log(e);
      /*if (this.orctoData.id === 0) {
        this.title = "Novo Orçamento";
      } else {
        this.title = `Editando Orçamento: ${this.orctoData.id}`;
      }*/
    },

    /*onRowDblClick(row) {
      console.log("onRowDblClick");

      let idRow = row.data.id;
      let idProd = row.data.produto_id;
      let Prod = row.data.produto;

      this.idRow = idRow;
      this.idProd = idProd;
      this.Prod = Prod;
      // this.editarProduto(idProd);
      this.showModalAcao = true;
    },*/

    /*onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "desconto") {
          const valdesconto = e.data.desconto;
          let cordesconto = "";

          if (valdesconto > 0.0) {
            cordesconto = "rgba(146,20,0,0.5)";
          } else if (valdesconto <= 0.0) {
            cordesconto = "rgba(33,78,0,0.5)";
          }

          if (cordesconto) {
            e.cellElement.style.cssText = `color: white; background-color: ${cordesconto}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "aconferirqtd") {
          const valaconferir = e.data.aconferirqtd;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "conferidoqtd") {
          const valconferir = e.data.conferidoqtd;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtddisp") {
          const valaconferir = e.data.qtddisp;
          const qtd = e.data.qtd;
          let coraconferir = "";

          if (valaconferir > 0.0 && valaconferir === qtd) {
            coraconferir = "";
          } else if (valaconferir > 0.0) {
            coraconferir = "rgba(191,147,9,0.5)";
          } else if (valaconferir === 0.0) {
            coraconferir = "rgba(33,78,0,0.5)";
          }

          if (coraconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${coraconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "qtdlida") {
          const valconferir = e.data.qtdlida;
          const qtd = e.data.qtd;
          let corconferir = "";

          if (valconferir === 0.0) {
            corconferir = "";
          } else if (valconferir > 0.0 && valconferir < qtd) {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valconferir === qtd) {
            corconferir = "rgba(33,78,0,0.5)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }

        if (e.column.dataField === "status") {
          const valstatus = e.data.status;
          let corconferir = "";

          if (valstatus === "ES") {
            corconferir = "rgba(6,119,221,0.85)";
          } else if (valstatus === "AB") {
            corconferir = "rgba(191,147,9,0.5)";
          } else if (valstatus === "SE") {
            corconferir = "rgba(33,78,0,0.5)";
          } else if (valstatus === "CP") {
            corconferir = "rgb(51,122,183)";
          }

          if (corconferir) {
            e.cellElement.style.cssText = `color: white; background-color: ${corconferir}`;
          } else {
            e.cellElement.style.cssText = "";
          }
        }
      }
    },*/

    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refeFormTable() {
      console.log("refeFormTable");
      this.dataGrid.state(null);
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'FA':
          return 'Faturado (FA)'
        case 'EL':
          return 'Em Elaboração (EL)'
        case 'CP':
          return 'Conf. Parcial (CP)'
        case 'CO':
          return 'Confirmado (CO)'
        case 'CA':
          return 'Cancelado (CA)'
        case 'SC':
          return 'Solicitação cancelamento (SC)'
        case 'EX':
          return 'Exportado (EX)'
      }

      return 'Não Definido'
    },

    deletaReg(dataID) {
      console.log('deletaReg_pai dataID:')
      console.log(dataID)
      this.loadingList = true
      api.delete(`${getBaseUrl()}api/monitora`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    relEFDFiscal(){
      console.log('relEFDFiscal')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: {
          periodo: this.periodo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data[1]
        const fileName = "EFD_Fiscal_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relEFDPisCofins(){
      console.log('relEFDPisCofins')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data
        const fileName = "EFD_PisCofins_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relResultados(){
      console.log('relResultados')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true

      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    confirmaPeriodoPesq() {
      console.log('confirmaPeriodoPesq')

      localStorage.setItem('filtros', JSON.stringify({
        'tipoFilter': this.periodoPesq
      }))

    },


    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      // this.carregarDados()
    },

    formatDecimal(value){
      // console.log('format_value')
      // console.log('value')
      // console.log('typeof value')
      let value_n = parseFloat(value);
      return value_n .toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },


  },


}
</script>

<template>
  <Layout>


    <span class="float-end" style="z-index: 1; position: absolute; top: 10px; right: 140px;">
      <Vue3Lottie :animationData="animationJson" :height="250" :width="250" />
    </span>

    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mt-4" v-if="!updating" style="z-index: 2; position: relative;">
              <div class="col-sm-2">
                <div class="col-sm-12 text-muted">
                  <h5>Selecione o Período do Relatório</h5>
                </div>
              </div>

              <div class="col-sm-1 mt-0">
                <div class="search-box d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="row col-sm-9 text-start">
              </div>
            </div>

            <div class="row mt-4" v-if="!updating">
              <div class="col-sm-2">
                <div class="col-sm-12 mx-2 mt-4" style="width: 150px">
                  <label for="periodoPesq"> Tipo do Filtro </label>
                  <div class="d-flex align-items-center justify-content-between" style="margin-top: -8px">
                    <b-form-checkbox
                        id="periodoPesq"
                        switch
                        size="md"
                        @change="confirmaPeriodoPesq"
                        v-model="periodoPesq">
                      {{ periodoPesq === true ? 'Filtrar Período' : 'Filtrar Mês' }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div class="row col-sm-9 text-start">
                <div v-if="periodoPesq === false" class="col-md-2 mb-3">
                  <label for="periodo">Filtro Mensal</label>
                  <input
                      id="periodo"
                      v-model="periodo"
                      type="month"
                      @change="mudouPeriodo"
                      class="form-control"
                      style="max-width: 200px;"
                      placeholder="Início"/>
                </div>

                <div v-if="periodoPesq === false" class="col-md-2 mb-3"></div>

                <div v-if="periodoPesq === true" class="col-md-2 mb-3">
                  <label for="dtIniFiltro">Dt. Início</label>
                  <input
                      id="dtIniFiltro"
                      v-model="dtIniFiltro"
                      type="date"
                      class="form-control"
                      style="max-width: 200px;"
                      placeholder="Data Início"
                      :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
                  <div v-if="submittedPeriodo && !dtIniFiltro"
                       class="invalid-feedback">
                    <span>Campo data início obrigatório, favor preencher.</span>
                  </div>
                </div>

                <div v-if="periodoPesq === true" class="col-md-2 mb-3">
                  <label for="dtFimFiltro">Dt. Final</label>
                  <input
                      id="dtFimFiltro"
                      v-model="dtFimFiltro"
                      type="date"
                      class="form-control"
                      style="max-width: 200px;"
                      placeholder="Data Final"
                      :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
                  <div v-if="submittedPeriodo && !dtFimFiltro"
                       class="invalid-feedback">
                    <span>Campo data final obrigatória, favor preencher.</span>
                  </div>
                </div>

                <div class="col-md-3 mt-4 text-center">
                </div>

                <div class="row col-sm-1" style="margin-top: 26px;" >
                  <div>
                    <b-button variant="primary"
                              style="padding: 6.5px 50px"
                              @click="confirmarPeriodo">
                      <i class="bx bx-search"></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-1 text-end" style="margin-top: 20px;">
                <b-dropdown
                    toggle-class=" font-size-12 mx-2"
                    variant="outline-primary"
                    right
                    class="ms-auto"
                    style="padding: 6.5px 5px"
                    menu-class="dropdown-menu-end">

                  <template #button-content>
                    <i class="bx bx-file"></i> Export
                  </template>

                  <b-dropdown-item href="#" @click="confirmaPeriodoPesq"> Relatório 1 </b-dropdown-item>
                  <b-dropdown-item href="#" @click="confirmaPeriodoPesq"> Relatório 2 </b-dropdown-item>
                  <b-dropdown-item href="#" @click="confirmaPeriodoPesq"> Relatório 3 </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>

            <div class="table-responsive mt-2">
              <Loader v-if="loadingList" style="min-height: 300px;">
              </Loader>

              <div class="mt-4">
                <DxToolbar>
                  <DxItem location="before" widget="dxButton">
                    <DxButton
                        icon="refresh"
                        hint="Redefinir formatação de tabela para padrão"
                        :on-click="refeFormTable"
                    />
                  </DxItem>
                </DxToolbar>
              </div>

              <div class="mt-0" v-if="!updating">
                <DxDataGrid
                    ref="dataGridRefKey"
                    :data-source="orcamentoList"
                    :show-borders="true"
                    :focused-row-enabled="true"
                    :keyExpr="'id'"
                    :column-auto-width="true"
                    :show-row-lines="true"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :row-alternation-enabled="true"
                    @content-ready="carregouGrid"
                    @exporting="onExporting"
                >
                  <DxRemoteOperations
                      :filtering="true"
                      :paging="true"
                      :sorting="true"
                      :summary="true"
                      :grouping="false"
                      :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true" />
                  <DxColumnFixing :enabled="true" />
                  <DxFilterRow :visible="false" />

<!--                  <DxSelection mode="multiple" />-->

                  <DxExport
                      :enabled="true"
                      :allow-export-selected-data="true"
                  />
                  <DxStateStoring
                      :enabled="true"
                      type="sessionStorage"
                      storage-key="strWmsOsEntradaList"
                  />

                  <DxGroupPanel :visible="false" />
                  <DxGrouping />

                  <DxColumn
                      :width="50"
                      data-field="id"
                      caption="ID"
                      sort-order="desc"
                      data-type="number"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="numped"
                      caption="Nro. Pedido"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="codigo"
                      caption="Codigo"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="empresa.nome"
                      caption="Empresa Nome"
                      data-type="text"
                      alignment="center"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="empresa.cnpj"
                      caption="Empresa Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="pessoa_cliente.nome"
                      caption="Cliente"
                      data-type="text"
                      alignment="center"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="pessoa_cliente.cnpj"
                      caption="Cliente Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="status"
                      caption="Status"
                      data-type="text"
                      alignment="center"
                      :customize-text="nomeStatus"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="agregped_id"
                      caption="Pedido agreg."
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="dtemissao"
                      caption="Dt. Emissao"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="natureza.descricao"
                      caption="Natureza"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="condpgto"
                      caption="Cód. CondPgto"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="condicao_pagamento.descricao"
                      caption="Condição Pgto"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="formapgto"
                      caption="Cód. FormaPgto"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="forma_pagamento.descricao"
                      caption="Forma Pgto"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="representante.descricao"
                      caption="Representante"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="valorprd"
                      caption="Vlr Produto (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="valorbrt"
                      caption="Valor (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="pesobrt"
                      caption="Peso (Kg)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />



                  <DxColumn
                      data-field="desconto"
                      caption="Desconto (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      :width="180"
                      data-field="tranportador.nome"
                      caption="Transp. Nome"
                      data-type="text"
                      alignment="center"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="tranportador.cnpj"
                      caption="Transp. Cnpj"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="valorfrt"
                      caption="Vlr Frete (R$)"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="wmsroma_id"
                      caption="ID Romaneio"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="segto"
                      caption="Seguimento"
                      data-type="text"
                      alignment="right"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="created_by"
                      caption="Criador"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="created_at"
                      caption="Dt. Criação"
                      alignment="right"
                      :format="formatDateTime"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="obs"
                      caption="Obs"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['contains','notcontains','startswith','endswith','=','<>',]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="false"
                  />

                  <DxPager
                      :visible="true"
                      :show-page-size-selector="true"
                      :allowed-page-sizes="[10, 30, 50, 100]"
                      :show-navigation-buttons="true"
                      :show-info="true"
                  />
                </DxDataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>

